import Vue from "vue";
import Router from "vue-router";
import Routes from "./routes";
//google-analytics
import ga from 'vue-ga';

Vue.use(Router);

// Netlify configured to redirect /* to /index.html to prevent 404; dont forget to setup redirects or set hash mode in case of host switch
const router = new Router({
  mode: "history",
  routes: Routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      if (savedPosition) {
        setTimeout(() => {
          resolve(savedPosition)
        }, 400)
      } else {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 400)
      }
    })
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
    document.head.querySelector('meta[name=description]').content = to.meta.description;
  }
  next();
})

ga(router, 'UA-93963779-4');

export default router;



// WEBPACK FOOTER //
// ./client/router/index.js